import styled from '@emotion/styled';

import { useRef } from 'react';

import { Header, Intro } from '@components';
import { Copyright } from '@features';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

interface LayoutProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const headerRef = useRef<HTMLDivElement | null>(null);
  return (
    <Container>
      <Header ref={headerRef} />
      <Intro />
      <Content>
        {children}
        <StyledCopyright />
      </Content>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: grid;
`;

const Content = styled.div`
  position: relative;
`;

const StyledCopyright = styled(Copyright)`
  position: sticky;
  left: 40px;
  bottom: 40px;

  ${getMediaqueryStyled('lg')} {
    left: 25px;
    bottom: 25px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;
